import api from "../api/api";

class ProfileService {
    async getAllPaginate(search: string, page: string | null) {
        let q = '';
        if (search?.length > 0) {
            q = `?q=${search}`;
            q += page ? `&page=${page}` : "";
            return await api.get(`/profile${q}`).then(r => r.data).catch(err => err);
        } else {
            if (page) {
                return await api.get(`/profile?page=${page}`).then(r => r.data).catch(err => err);
            } else {
                return await api.get(`/profile`).then(r => r.data).catch(err => err);
            }
        }
    }

    async get(id: string) {
        return await api.get(`/profile/${id}`).then(response => response.data).catch(err => err);
    }

    async create(data: any) {
        return await api.post("/profile", data).then(response => response.data);
    }

    async update(id: string, data: any) {
        
        return await api.put(`/profile/${id}`, data).then(response => response.data);
    }

    async delete(id: string) {
        return await api.delete(`/profile/${id}`).then(response => response.data);
    }
}

const profileService = new ProfileService();

export default profileService;